{
  "collect": "Lấy mẫu bệnh phẩm",
  "track": "Theo dõi mẫu bệnh phẩm",
  "accession": "Số tiếp nhận",
  "barcode": "Mã vạch",
  "status": {
    "ordered": "Đã chỉ định",
    "collected": "Đã lấy mẫu",
    "inTransit": "Đang vận chuyển",
    "received": "Đã tiếp nhận",
    "processing": "Đang xử lý",
    "resulted": "Đã có kết quả",
    "rejected": "Rejected",
    "in_transit": "Đang vận chuyển"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
